import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import FontAwesome from 'react-fontawesome';
import Renderlist from './renderdetail';

const ConfirmSubmit = ({
  button1,
  isOpen,
  header,
  onCancel,
  onConfirm,
  message,
  list,
  onDisAprove,
  value,
  onChange,
  error,size ="lg"
}) => {

  return (
    <div>
      <Modal
        isOpen={isOpen}
        toggle={onCancel}
        size={size}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <ModalHeader> 
       
        {list && list.length >0 &&
      
         <span className="font-weight-normal">
          {list[0].weightno}
       </span>
        }
        </ModalHeader>
        <ModalBody>

          { list && <Renderlist
          list ={list}
          
          />}
         

          {!list && message}
        </ModalBody>
        { error && <div className="col-md-12 alert alert-danger">  { error}</div>}

        {list && list.comment &&
            <Button color="danger">
              {list.comment}
            </Button>
          }
        <ModalFooter>
          <Button color="secondary" onClick={onCancel}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ConfirmSubmit;
